<template>
    <div class="d-inline-block creative-popper">
        <popper trigger="click" :options="{ placement: 'left' }">
            <div class="popper creative-popper-inner popper-lg" v-if="creative">
                <t-carousel :items="creative">
                    <template slot-scope="{ next, previous, currentItem, currentCount, itemCount }">
                        <div class="row switcher">
                            <div class="col-2">
                                <button class="btn prev" v-if="itemCount > 1" @click="previous">
                                    <i class="fal fa-chevron-left fa-fw"></i>
                                    <span class="sr-only">Previous Creative</span>
                                </button>
                            </div>
                            <div class="col-8 popper-content">
                                <div class="counter" v-if="itemCount > 1">{{ currentCount }} of {{ itemCount }}</div>
                                <div v-if="currentItem" class="current-item">
                                    <div class="current-item-content">
                                        <display-creative :creative="currentItem" :key="currentItem._uid"></display-creative>
                                    </div>
                                </div>
                            </div>
                            <div class="col-2">
                                <button class="btn next" v-if="itemCount > 1" @click="next">
                                    <i class="fal fa-chevron-right fa-fw"></i>
                                    <span class="sr-only">Next Creative</span>
                                </button>
                            </div>
                        </div>
                        <div class="row popper-footer">
                            <div class="col current-item-description" v-if="currentItem">
                                {{ currentItem.name }}<br />{{ currentItem.start_date }}
                            </div>
                        </div>
                    </template>
                </t-carousel>
            </div>
            <a href="#" slot="reference" class="popper-reference">
                <slot>Creative</slot>
            </a>
        </popper>
    </div>
</template>

<script>
import DisplayCreative from '@/shared/creative/DisplayCreative';
import Creative from '@js/models/Creative';
import { BPopover } from 'bootstrap-vue';

export default {
    components: { DisplayCreative, BPopover },
    props: {
        item: {
            required: true,
        },
        icon: {
            default: true,
        },
    },
    data: () => ({
        creative: [],
    }),
    watch: {
        item: {
            deep: true,
            immediate: true,
            handler(newVal) {
                const self = this;
                if (newVal.$resource === 'creative') {
                    this.creative.push(newVal);
                } else if (newVal.$resource === 'order-asset') {
                    if (newVal.is_bundle) {
                        _.each(newVal.children, (child) => {
                            _.each(child.order_items, (item) => {
                                _.each(item.creative, (creative) => {
                                    creative.start_date = item.start_date;
                                    creative.name = item.name;
                                    self.creative.push(new Creative(creative));
                                });
                            });
                        });
                    } else {
                        _.each(newVal.order_items, (item) => {
                            _.each(item.creative, (creative) => {
                                creative.name = item.name;
                                creative.start_date = item.start_date;
                                self.creative.push(new Creative(creative));
                            });
                        });
                    }
                } else if (newVal.creative) {
                    _.each(newVal.creative, (creative) => {
                        creative.name = newVal.name;
                        creative.start_date = newVal.start_date;
                        self.creative.push(creative);
                    });

                    _.each(newVal.children, (child) => {
                        _.each(child.creative, (creative) => {
                            creative.name = newVal.name;
                            creative.start_date = newVal.start_date;
                            self.creative.push(creative);
                        });
                    });
                }
            },
        },
    },
};
</script>
